// libs
import React, { ReactElement } from 'react';
import { useRouter } from 'next/router';
import { Icon } from 'ui-components';
// App
import styles from './brand.module.scss';

import FrenchFlagIcon from './icons/french-flag.svg';
import { BrandProps } from './brand.interfaces';

const Brand = (props: BrandProps): ReactElement => {
  const { className, showFrenchFlag = false, url } = props;
  const router = useRouter();

  /**
   * Redirect to home page
   */
  const handleGoToHome = () => {
    router.push(url || '/');
  };

  return (
    <div className={`${styles.container} ${className || ''}`}>
      <Icon name="brand" className={`${styles.brandIcon}`} onClick={handleGoToHome} />
      {showFrenchFlag && <FrenchFlagIcon className={`${styles.frenchFlagIcon}`} />}
    </div>
  );
};

export default Brand;
